import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.75 12.75C8.75 10.9551 10.2051 9.5 12 9.5C13.7949 9.5 15.25 10.9551 15.25 12.75C15.25 14.5449 13.7949 16 12 16C10.2051 16 8.75 14.5449 8.75 12.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.88197 2H16.118L17.618 5H23V21H1V5H6.38197L7.88197 2ZM6.75 12.75C6.75 15.6495 9.1005 18 12 18C14.8995 18 17.25 15.6495 17.25 12.75C17.25 9.8505 14.8995 7.5 12 7.5C9.1005 7.5 6.75 9.8505 6.75 12.75Z"}}]};

const CameraFilled = Vue.extend<IconProps>({
  name: 'CameraFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'camera-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CameraFilled;
